module.exports = __webpack_public_path__ + "img/3eca127.jpg";